import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom'
import Home from './routes/home/Home';
import Header from './components/header/Header';
import Locations from './routes/locations/Locations';
import Location from './routes/location/Location';

import './App.css';

export default withRouter(class App extends Component {
  render() {
    return (
        <div className="container">
          <Header />

          <Switch>
            <Route exact path='/' component={Home}/>
            <Route exact path='/locations' component={Locations}/>
            <Route exact path='/location/:slug' component={Location}/>
          </Switch>
        </div>
    );
  }
})




// WEBPACK FOOTER //
// ./src/App.js